/**
 * Credit Note print page — mounted OUTSIDE the protected <Layout> (same
 * reasoning as PublicInvoice.js: no CRM navbar baked into the PDF). The
 * underlying GET /api/credit-notes/{id}/document endpoint is Admin/Accounts-
 * only, so this route is NOT actually public despite living alongside the
 * public routes — the global axios interceptor (index.js) forwards the
 * localStorage Bearer token on every request, same plumbing already proven
 * for the voucher/invoice/itinerary Playwright PDF pipeline.
 */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import CreditNoteDocument from './CreditNoteDocument';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function CreditNotePreview() {
  const { creditNoteId } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.body.classList.add('pdf-public-route');
    return () => document.body.classList.remove('pdf-public-route');
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/credit-notes/${creditNoteId}/document`);
        if (!cancelled) {
          setData(res.data);
          document.title = res.data?.creditNoteNumber || 'Credit Note';
        }
      } catch {
        if (!cancelled) setError('Failed to load credit note');
      }
    })();
    return () => { cancelled = true; };
  }, [creditNoteId]);

  if (error) return <div style={{ padding: 24 }} data-testid="credit-note-preview-error">{error}</div>;
  if (!data) return <div style={{ padding: 24 }}>Loading…</div>;
  return (
    <div className="py-6" data-testid="credit-note-preview-page">
      <CreditNoteDocument data={data} />
    </div>
  );
}
